export default __webpack_public_path__ + "static/media/predictions.631d1e2c.svg";